import { curry } from "ramda"
import isRequired from "./isRequired"

export default curry((fn, { value, forminputdata }) => {
  if (!isRequired({ value })) {
    return true
  }
  return fn({ value, forminputdata })
})
